<template>
  <v-app>
    <component v-bind:is="layout"></component>
    <div class="text-center">
      <v-snackbar v-model="$store.state.loginRequired" :multi-line="true">
        Session is timed-out. Please login.
        <template v-slot:action="{ attrs }">
          <v-btn color="blue" text v-bind="attrs" @click="goToLogin">
            Login
          </v-btn>
        </template>
      </v-snackbar>
    </div>
  </v-app>
</template>

<script>
const defaultLayout = "main";

export default {
  computed: {
    layout() {
      return (this.$route.meta.layout || defaultLayout) + "-layout";
    },
  },
  methods: {
    goToLogin() {
      this.$store.state.loginRequired = false;
      window.open(
        "/login-small",
        "_blank",
        "toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=500,height=500"
      );
    },
  },
};
</script>
